var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#E6EFF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.7258C8.5 11.058 9.04183 10.5161 9.70968 10.5161H12.129C12.7994 10.5161 13.3387 11.058 13.3387 11.7258V14.1452C13.3387 14.8155 12.7994 15.3549 12.129 15.3549H9.70968C9.04183 15.3549 8.5 14.8155 8.5 14.1452V11.7258ZM11.7258 13.742V12.129H10.1129V13.742H11.7258ZM32.6935 12.129C33.1371 12.129 33.5 12.4899 33.5 12.9355C33.5 13.379 33.1371 13.742 32.6935 13.742H16.5645C16.121 13.742 15.7581 13.379 15.7581 12.9355C15.7581 12.4899 16.121 12.129 16.5645 12.129H32.6935ZM32.6935 20.1936C33.1371 20.1936 33.5 20.5565 33.5 21C33.5 21.4436 33.1371 21.8065 32.6935 21.8065H16.5645C16.121 21.8065 15.7581 21.4436 15.7581 21C15.7581 20.5565 16.121 20.1936 16.5645 20.1936H32.6935ZM32.6935 28.2581C33.1371 28.2581 33.5 28.621 33.5 29.0645C33.5 29.5081 33.1371 29.871 32.6935 29.871H16.5645C16.121 29.871 15.7581 29.5081 15.7581 29.0645C15.7581 28.621 16.121 28.2581 16.5645 28.2581H32.6935ZM12.129 18.5807C12.7994 18.5807 13.3387 19.12 13.3387 19.7903V22.2097C13.3387 22.8801 12.7994 23.4194 12.129 23.4194H9.70968C9.04183 23.4194 8.5 22.8801 8.5 22.2097V19.7903C8.5 19.12 9.04183 18.5807 9.70968 18.5807H12.129ZM10.1129 20.1936V21.8065H11.7258V20.1936H10.1129ZM8.5 27.8549C8.5 27.1845 9.04183 26.6452 9.70968 26.6452H12.129C12.7994 26.6452 13.3387 27.1845 13.3387 27.8549V30.2742C13.3387 30.9446 12.7994 31.4839 12.129 31.4839H9.70968C9.04183 31.4839 8.5 30.9446 8.5 30.2742V27.8549ZM11.7258 29.871V28.2581H10.1129V29.871H11.7258Z",
    fill: "#173593"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 8,
    stroke: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.500f813d1e1f68a54d3ce9451292614c.svg";
export { ForwardRef as ReactComponent };